import React, {Component} from 'react';

export default class SearchField extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.campoBusca = this.props.campoBusca;
    }

    render() {
        return(
            <div className="search-field">
                <label htmlFor="search-bar-0" className="search-label">
                    <input type="text" className="form-control" placeholder={this.props.placeholder} onInput={e => this.controller.adicionarFiltro(this.campoBusca,e.target.value)}></input>
                </label>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/comum/components/SearchField.js